import styled from '@emotion/styled';
import GenericCalendar from '@/components/atoms/Calendar';

export const Row = styled.div`
    display: flex;
    align-items: flex-start;
    margin-bottom: ${({ theme }) => theme.spacing[4]};
`;

export const LogsContainer = styled.div`
    background-color: ${({ theme }) => theme.color.slate100};
    border: 1px solid ${({ theme }) => theme.color.slate200};
    border-radius: ${({ theme }) => theme.radius.main};
    padding: ${({ theme }) => theme.spacing[3]};
    margin: ${({ theme }) => theme.spacing[4]} 0;
    max-height: 400px;
    overflow-y: auto;
    font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
    font-size: 12px;
    line-height: 1.4;
    box-shadow: ${({ theme }) => theme.shadow.inside[100]};
`;

export const LogLine = styled.div<{ isStreaming?: boolean }>`
    color: ${({ theme }) => theme.color.white100};
    margin: 2px 0;
    padding: 2px 4px;
    white-space: pre-wrap;
    word-break: break-word;

    ${({ isStreaming, theme }) =>
        isStreaming &&
        `
        &:last-child {
            position: relative;
            
            &::after {
                content: '▊';
                color: ${theme.color.emerald};
                animation: blink 1s infinite;
            }
        }
        
        @keyframes blink {
            0%, 50% { opacity: 1; }
            51%, 100% { opacity: 0; }
        }
    `}
`;

export const Calendar = styled(GenericCalendar)`
    width: 100%;
    div.react-datepicker {
        border-top: 0;
        width: 100%;
    }
`;
